import React from 'react';
export function PaymentInfo({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`mt-5 text-center font-inter ${className}`} data-id="element-123">
      <p className="text-gray-400 text-sm mb-2" data-id="element-124">
        Pagá con MercadoPago o PayPal según tu país.
      </p>
      <div className="flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-gray-500" data-id="element-125">
        <span data-id="element-126">✔ Tarjetas internacionales</span>
        <span data-id="element-127">✔ MercadoPago (Argentina)</span>
        <span data-id="element-128">✔ PayPal (global)</span>
        <span data-id="element-129">✔ Acceso inmediato</span>
      </div>
    </div>;
}